import React from 'react';

const Plus = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="element/button/icon/enabled-copy-2" transform="translate(-8.000000, -4.000000)">
                <g id="icons/add-open" transform="translate(8.000000, 4.000000)" fill="#0852E0">
                    <path
                        d="M13,11 L17,11 L17,13 L13,13 L13,17 L11,17 L11,13 L7,13 L7,11 L11,11 L11,7 L13,7 L13,11 Z"
                        id="add"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default Plus;
